import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'lfw-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css'],
  imports: [MatProgressBar]
})
export class LogOutComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit() {
    console.log('... logging out ...');
    this.authService.logout();
  }
}
